import { PayloadAction } from '@reduxjs/toolkit'
import {
  BalanceType
} from 'src/core/models'
import { initialState } from 'src/features/summary/state'

const reducers = {
  /* Balance Reducers */
  setBalanceLoading: (state, action: PayloadAction<boolean>) => {
    state.balance.loading = action.payload
  },
  setBalanceResponse: (state, action: PayloadAction<BalanceType[]>) => {
    state.balance.list = action.payload
  },
  setBalanceError: (state, action: PayloadAction<string>) => {
    state.balance.error = action.payload
  },
  setFilter: (state, action: PayloadAction<number>) => {
    state.filter = action.payload
  },
  /* Sales Data Reducers */
  setSalesDataLoading: (state, action: PayloadAction<boolean>) => {
    state.salesData.loading = action.payload
  },
  setSalesDataResponse: (state, action: PayloadAction<any[]>) => {
    state.salesData.list = action.payload
  },
  setSalesDataError: (state, action: PayloadAction<string>) => {
    state.salesData.error = action.payload
  },
  setSalesDataPlot: (state, action: PayloadAction<boolean>) => {
    state.salesData.plotData = action.payload
  },

  /* Orders Data Reducers */
  setOrdersDataLoading: (state, action: PayloadAction<boolean>) => {
    state.ordersData.loading = action.payload
  },
  setOrdersDataResponse: (state, action: PayloadAction<any[]>) => {
    state.ordersData.list = action.payload
  },
  setOrdersDataError: (state, action: PayloadAction<string>) => {
    state.ordersData.error = action.payload
  },
  setOrdersDataPlot: (state, action: PayloadAction<boolean>) => {
    state.ordersData.plotData = action.payload
  },
  /* Deposit Reducers */
  setDepositLoading: (state, action: PayloadAction<boolean>) => {
    state.deposit.loading = action.payload
  },
  setDepositResponse: (state, action: PayloadAction<any[]>) => {
    state.deposit.response = action.payload
  },
  setDepositError: (state, action: PayloadAction<string>) => {
    state.deposit.error = action.payload
  },
  setDepositSuccess: (state, action: PayloadAction<boolean>) => {
    state.deposit.success = action.payload
  },
  resetDepositSuccessState: (state) => {
    state.deposit.success = initialState.deposit.success
  },
  setDepositPayPalUrl: (state, action: PayloadAction<string>) => {
    state.deposit.payPalUrl = action.payload
  },
  resetDepositPayPalUrlState: (state) => {
    state.deposit.payPalUrl = initialState.deposit.payPalUrl
  },
  setDepositCreditCardInfo: (state, action: PayloadAction<any>) => {
    state.deposit.creditCardInfo = action.payload
  },
  setDepositSubmit: (state, action: PayloadAction<boolean>) => {
    state.deposit.submit = action.payload
  },
  resetDepositSubmitState: (state) => {
    state.deposit.submit = initialState.deposit.submit
  },

  // Withdraw with PayPal
  setWithdrawPayPalLoading: (state, action: PayloadAction<boolean>) => {
    state.withdraw.loading = action.payload
  },
  setWithdrawPayPalSuccess: (state, action: PayloadAction<boolean>) => {
    state.withdraw.success = action.payload
  },
  setWithdrawPayPalError: (state, action: PayloadAction<boolean>) => {
    state.withdraw.error = action.payload
  },
  resetWithdrawPayPalState: (state) => {
    state.withdraw = initialState.withdraw
  },
}

export { reducers }
